import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPus = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPus.call(this, location).catch((err) => err)
}

export default new Router({
  routes: [
    {
      path: '',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {
        title: '企业综合驾驶舱'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js